<template>
    <div :class="{'chartPie':true,'hot':typeArr.indexOf(type) > -1}" :id="id"></div>
</template>

<script>
// import utils from "@/utils";

export default {
    name: "aiChartsPie",
    props: ['id', 'colors', 'data', 'text', 'type'],
    mounted () {
        this.$nextTick(() => {
            this.initChart()
        });
        // ai设置border
        if (this.type === 'ai') {
            this.peiBorderWidth = 0.5;
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    watch: {
        id () {
            this.$nextTick(() => {
                this.initChart()
            });
        }
    },
    data () {
        return {
            typeArr: ["cold", "poisson", "banker", "full"],
            peiBorderWidth: 0
        }
    },
    methods: {
        initChart (_color) {
            const self = this;
            const myCharts = this.$echarts.init(document.getElementById(self.id));
            let graphic = [];
            if (self.typeArr.indexOf(self.type) > -1) {
                graphic = [
                    { // 环形图中间添加文字
                        type: 'text', // 通过不同top值可以设置上下显示
                        left: 'center',
                        top: '35%',
                        style: {
                            text: self.text,
                            textAlign: 'center',
                            fill: self.isDark ? '#d6d6d6' : '#333333', // 文字的颜色
                            fontSize: 12,
                            fontWeight: 500
                        }
                    }
                ]
            } else {
                graphic = [
                    { // 环形图中间添加文字
                        type: 'text', // 通过不同top值可以设置上下显示
                        left: 'center',
                        top: '38%',
                        style: {
                            text: self.text,
                            textAlign: 'center',
                            fill: self.isDark ? '#d6d6d6' : '#333333', // 文字的颜色
                            fontSize: 18,
                            fontWeight: 500
                        }
                    }
                ]
            }
            const option = {
                tooltip: {
                    show: false,
                    trigger: 'none'
                },
                legend: {
                    show: false,
                    selectedMode: false
                },
                grid: {
                    left: '0%',
                    right: '0%',
                    top: '0%',
                    bottom: '0%',
                    containLabel: true
                },
                graphic: graphic,
                color: self.colors,
                series: [
                    {
                        name: '访问来源',
                        type: 'pie',
                        radius: ['76%', '92%'],
                        hoverAnimation: false,
                        itemStyle: {
                            borderRadius: 0,
                            borderColor: self.isDark ? '#191919' : '#fff',
                            borderWidth: self.peiBorderWidth
                        },
                        label: {
                            normal: {
                                show: false
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            }
                        },
                        data: self.data
                    }
                ]
            };
            myCharts.setOption(option)
        }
    }
}
</script>

<style scoped lang="less">
.chartPie{
    width: 60px;
    height: 60px;
    margin: 0 auto;
}
.chartPie.hot{
    width: 36px;
    height: 36px;
    margin: 2px auto 0;
}
</style>
